import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";

const Title = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
`;

const FieldGroup = styled.div`
    margin-bottom: 12px;
`;

const InputLabel = styled.label`
    display: block;
    margin-bottom: 5px;
    font-size: 14px;
    color: #555;
`;

const Input = styled.input`
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;

    &:focus {
        border-color: #007bff;
        outline: none;
        box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
`;

const BotoesWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
`;

const BotaoRemover = styled.button`
    padding: 8px 16px;
    background-color: transparent;
    color: #333;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #f0f0f0;
    }
`;

const BotaoAplicar = styled.button`
    padding: 8px 16px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #0056b3;
    }
`;

const ModalFiltersPedidosResumo = ({ fecharModal, filtros, setFiltros, aplicarFiltros, removerFiltros }) => {

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFiltros((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <Overlay state={true}>
            <Modal size="md" header close={fecharModal}>
                <Title>Filtros</Title>
                <FieldGroup>
                    <InputLabel htmlFor="filial">Filial:</InputLabel>
                    <Input
                        type="text"
                        id="filial"
                        name="filial"
                        value={filtros.filial}
                        onChange={handleChange}
                    />
                </FieldGroup>
                <FieldGroup>
                    <InputLabel htmlFor="numPedido">Número Pedido:</InputLabel>
                    <Input
                        type="text"
                        id="numPedido"
                        name="numPedido"
                        value={filtros.numPedido}
                        onChange={handleChange}
                    />
                </FieldGroup>
                <FieldGroup>
                    <InputLabel htmlFor="data-inicial">Data Emissão Inicial:</InputLabel>
                    <Input
                        type="date"
                        id="data-inicial"
                        name="dataInicio"
                        value={filtros.dataInicio}
                        onChange={handleChange}
                    />
                </FieldGroup>
                <FieldGroup>
                    <InputLabel htmlFor="data-final">Data Emissão Final:</InputLabel>
                    <Input
                        type="date"
                        id="data-final"
                        name="dataFim"
                        value={filtros.dataFim}
                        onChange={handleChange}
                    />
                </FieldGroup>
                <BotoesWrapper>
                    <BotaoRemover onClick={removerFiltros}>Remover Filtros</BotaoRemover>
                    <BotaoAplicar onClick={aplicarFiltros}>Aplicar Filtros</BotaoAplicar>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );
};

export default ModalFiltersPedidosResumo;
